import Script from 'next/script';

import type { SanityVevEmbedType } from '@/types/sanity';

export interface VevEmbedProps extends SanityVevEmbedType {}

export const VevEmbed = ({ vevURL, vevID }: VevEmbedProps) => {
  return (
    <>
      <Script src={vevURL} />
      <div id={vevID} />
    </>
  );
};
